import { useTranslation } from 'react-i18next';

import { DataPanel, DataPanelAutoWrapInlineItem } from '@/ui';
import { openEditPatientDescriptionDialog } from '../../actions';

export type PatientSectionProps = {
  incidentId: string;
  description: string | null;
  incidentIsReadOnly: boolean;
};

export function PatientSection({ incidentId, description, incidentIsReadOnly }: PatientSectionProps) {
  const { t } = useTranslation();

  return (
    <DataPanel
      header={t('Incident_InfoPanel_Patient_PanelHeader')}
      defaultExpanded={description != null && description.trim() !== ''}
    >
      <DataPanelAutoWrapInlineItem
        title={t('Incident_InfoPanel_Patient_Description')}
        value={description ?? undefined}
        editable={!incidentIsReadOnly}
        showEmptyPlaceholder
        onEditClick={() => openEditPatientDescriptionDialog(incidentId, description)}
      />
    </DataPanel>
  );
}
